import { RouteType } from 'types/RouteType';
import { ServiceStore, RouterStore } from '@intrasync/stores';

const dispatchDashboardRoute: RouteType = {
  name: 'Dispatch Dashboard',
  path: '/job/:jobNumber/dispatch-dashboard',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Dispatch Dashboard',
      component: () => import('./DispatchDashboard.Header'),
      enableToolbox: true,
      enableBackButton: true,
      enableRefreshButton: true,
    },
    body: {
      component: () => import('./DispatchDashboard.Body'),
      grayBackground: true,
    },
  },
  group: 'Dispatch',
  requiresAuth: true,
  requiresPermission: false,
  permissionPath: '/app/dispatch-dashboard',
  channels: [
    'job/:jobNumber',
    'load/:jobNumber',
    'trailer',
    'panel-revit/:jobNumber',
    'panel-plant/:jobNumber',
    'panel-yard/:jobNumber',
  ],
  enableAutoFind: false,
  projectRoute: true,
  beforeEnter: async ({ rootStore }) => {
    const loadStore = rootStore.loadStore as ServiceStore;
    const trailerStore = rootStore.trailerStore as ServiceStore;
    const panelStore = rootStore.panelStore as ServiceStore;
    const jobStore = rootStore.jobStore as ServiceStore;

    const { params } = rootStore.routerStore as RouterStore;
    const jobNumber = params.jobNumber;

    try {
      await Promise.all([
        loadStore?.find({ query: { jobNumber } }),
        trailerStore?.find(),
        panelStore?.find({ query: { jobNumber } }),
        jobStore?.find({ query: { jobNumber } })
      ]);
      return true;
    } catch (error) {
      console.error('Error loading dispatch dashboard data:', error);
      return false;
    }
  },
};

export default dispatchDashboardRoute;